module.exports = __webpack_public_path__ + "static/media/loading.a6ec563b.gif";